var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"isLoading"}},[(_vm.isLoading)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"loader fixed"},[_c('span',{staticClass:"loading loading-lg"},[_c('inline-svg',{attrs:{"src":"/img/icons/loading.svg"}})],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }